import Rails from '@rails/ujs'
import ReactRailsUJS from 'react_ujs'

import onPageLoad from 'shared/on_page_load'

import 'landing_pages/form/functions'
import 'landing_pages/zip_code'
import 'landing_pages/address_autocomplete_legacy'
import 'landing_pages/tracking'
import 'landing_pages/modal'
import renderRoot from 'landing_pages/render'

Rails.start()
ReactRailsUJS.useContexts([
  require.context("landing_pages/components", true, /\/LandingPage$/),
]);

onPageLoad(() => {
  renderRoot()
})
